module.exports = __webpack_public_path__ + "static/Crystal_Glyph_Color.317b7189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crystal/Crystal_Glyph_Color.png
// module id = 71
// module chunks = 35783957827783 222309558401364 241894665707670